const dialog = require('../../../../../components/dialog/dialog')

export function start(detail){

      dialogBody[detail.id].start(detail)

      detail.html = dialogBody[detail.id]
      dialog.start(detail)
}

const dialogBody = {

      discardChanges: {
            title:    '',
            des:      '',
            bodyHtml: '',

            primary: {
                  text:       'Continue editing',
                  class:      'button primary',
                  dataDetail: '',
            },

            secondary: {
                  text:       'Discard',
                  class:      'button secondary button-flat',
                  dataDetail: '',
            },

            tertiary: {
                  text:       '',
                  class:      '',
                  dataDetail: '',
            },

            start: function(detail){

                  this.title = 'Discard Inventory Update changes?'
                  this.des   = 'The values entered in Qty and Selling Price will be lost.'

                  this.primary.dataDetail = `data-detail='{
                        "click": [
                              {"dest":"ripple"},
                              {"dest":"dialog", "act":"hide"}
                        ]}'`

                  this.secondary.dataDetail = `data-detail='{
                        "click": [
                              {"dest":"ripple"},
                              {"dest":"dialog", "act":"hide"},
                              {"dest":"inventoryUpdate", "elem":"fullcont", "id":"inventoryUpdate-fullcont", "act":"discard"}
                        ]}'`
            },
      },
}
